const monthNames = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
];
const dayOfWeekNames = [
    'Sunday',
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
];
/**
 * Returns the week number for this date.
 *
 * @author Nick Baicoianu at MeanFreePath: http://www.meanfreepath.com
 *
 * @param dowOffset the day of week the week "starts" on for your locale - it can be from 0 to 6. If dowOffset is 1 (Monday),
 * the week returned is the ISO 8601 week number.
 * @return the week number for this date
 */
export function getWeek(date, dowOffset = 0) {
    const newYear = new Date(date.getFullYear(), 0, 1);
    let day = newYear.getDay() - dowOffset; //the day of week the year begins on
    day = day >= 0 ? day : day + 7;
    const daynum = Math.floor((date.getTime() -
        newYear.getTime() -
        (date.getTimezoneOffset() - newYear.getTimezoneOffset()) * 60000) /
        86400000) + 1;
    let weeknum;
    // if the year starts before the middle of a week
    if (day < 4) {
        weeknum = Math.floor((daynum + day - 1) / 7) + 1;
        if (weeknum > 52) {
            const nYear = new Date(date.getFullYear() + 1, 0, 1);
            let nday = nYear.getDay() - dowOffset;
            nday = nday >= 0 ? nday : nday + 7;
            // if the next year starts before the middle of
            // the week, it is week #1 of that year
            weeknum = nday < 4 ? 1 : 53;
        }
    }
    else {
        weeknum = Math.floor((daynum + day - 1) / 7);
    }
    return weeknum;
}
/**
 * Format date as a string
 * For example `YYYY-mm-dd` will output 2020-01-27
 * @param date
 * @param patternStr
 */
export function dateFormat(date, patternStr) {
    const day = date.getDate(), dayOfWeek = date.getDay(), month = date.getMonth(), year = date.getFullYear(), hour = date.getHours(), minute = date.getMinutes(), second = date.getSeconds(), miliseconds = date.getMilliseconds(), week = getWeek(date), h = hour % 12, hh = twoDigitPad(h), HH = twoDigitPad(hour), mm = twoDigitPad(minute), ss = twoDigitPad(second), aaa = hour < 12 ? 'AM' : 'PM', EEEE = dayOfWeekNames[date.getDay()], EEE = EEEE.substr(0, 3), dd = twoDigitPad(day), M = month + 1, MM = twoDigitPad(M), MMMM = monthNames[month], MMM = MMMM.substr(0, 3), yyyy = year + '', yy = yyyy.substr(2, 2), ww = twoDigitPad(week);
    // checks to see if month name will be used
    patternStr = patternStr
        .replace('hh', hh)
        .replace('h', h.toString())
        .replace('HH', HH)
        .replace('H', hour.toString())
        .replace('mm', mm)
        .replace('m', minute.toString())
        .replace('ss', ss)
        .replace('s', second.toString())
        .replace('S', miliseconds.toString())
        .replace('dd', dd)
        .replace('d', day.toString())
        .replace('D', dayOfWeek.toString())
        .replace('ww', ww)
        .replace('w', week.toString())
        .replace('EEEE', EEEE)
        .replace('EEE', EEE)
        .replace('yyyy', yyyy)
        .replace('yy', yy)
        .replace('aaa', aaa);
    if (patternStr.indexOf('MMM') > -1) {
        patternStr = patternStr.replace('MMMM', MMMM).replace('MMM', MMM);
    }
    else {
        patternStr = patternStr.replace('MM', MM).replace('M', M.toString());
    }
    return patternStr;
}
function twoDigitPad(num) {
    return num < 10 ? '0' + num : num.toString();
}
